import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { Subscription } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { SchemeService } from '../../services/scheme.service';
import { PermissionsService } from '../../services/permission.service';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../editorconfig';
import { FileUpload } from 'primeng/fileupload';
import { TableModule } from 'primeng/table';
import { UploadDocumentComponent } from '../../components/upload-document/upload-document.component';

@Component({
  selector: 'app-revenue-scheme-list',
  standalone: false,
  templateUrl: './revenue-scheme-list.component.html',
  styleUrl: './revenue-scheme-list.component.scss',
})
export class RevenueSchemeListComponent implements OnInit {
  @ViewChild('dt') table: TableModule;
  @ViewChild('createProposal') createProposal?: ElementRef<HTMLElement>;
  @ViewChild('uploadDoc') uploadDocumentComponent!: UploadDocumentComponent;

  isSkipStep: boolean = false;
  skipReason: string = '';
  proposalData: any[] = [];
  // currentPage: number = 1; // Commented out - using PrimeNG pagination
  // itemsPerPage: number = 9; // Commented out - using PrimeNG pagination
  addProposalVisible: boolean = false;
  stages: any[] = [];
  schemes = [];
  proposalForm: FormGroup;
  filteredSchemes: any[] = [];
  selectedScheme: any = null;
  isUpdateProposal: boolean = false;
  selectedProposal: any;
  isDeleteProposal: boolean = false;
  filteredRecentProposals: any;
  routeForm: FormGroup;
  RouteUserList: any[] = [];
  userListCopy: any;
  unitList = [];
  tabList: any;
  activeTabIndex = 0;
  addMode: 'new' | 'existing' = 'new';
  activeTabName: string = '';
  selectedPhaseId: any;
  currentPhaseName: string = '';
  previousPhaseStages: any[] = [];
  transactionPhaseStages: any[] = [];
  searchProposalQuery: string = '';
  activeIndex = 0;
  items: any;
  selectedProposals: any[] = [];
  lazy: boolean = true;
  draftProposalColumns: any[] = [
    { field: 'nomenclature', header: 'Name', filterType: 'text' },
    { field: 'modified_on', header: 'Last Update', filterType: 'text' },
  ]
  // Proposal status tabs
  proposalStatusTabs = [
    { label: 'Draft Proposals', status: 'form', active: true, tab: 0 }, // Special status for form
    { label: 'Pre APSO Approval', status: 'initiated', active: false, tab: 1 }, // Show initiated proposals
    { label: 'Ongoing Proposals', status: 'in_review', active: false, tab: 1 }, // Show initiated proposals
    { label: 'Completed Proposal', status: 'approved', active: false, tab: 1 },
    { label: 'Short Closed Proposal', status: 'short_close', active: false, tab: 1 },
    // { label: 'Rejected Proposal', status: 'rejected', active: false, tab: 1 },
  ];
  tableColumns = [
    { field: 'actions', header: 'Actions', filterType: 'text', filter: false },
    { field: 'checkbox', header: '', filterType: 'text', filter: false },
    { field: 'directorate', header: 'Directorate', filterType: 'text', filter: true },
    { field: 'name', header: 'Name', filterType: 'text', filter: true },
    { field: 'description', header: 'Description', filterType: 'text', filter: true },
    { field: 'steps', header: 'Steps', filterType: 'text' },
    { field: 'progress', header: 'Progress', filterType: 'text', filter: true },
    { field: 'proposal_status', header: 'Status', filterType: 'text', filter: true }
  ];
  activeStatusTabIndex: any = this.proposalStatusTabs[0];
  roleList = [];
  userList = [];
  steps: any[] = [];
  activePhaseId: any;
  stepId: number | null = null;
  roleID: number | null = null;
  userID: number | null = null;
  stagesList: any[] = [];
  userCols: any[] = [
    { field: 'user.first_name', header: 'First Name', filterType: 'text' },
    { field: 'user.last_name', header: 'Last Name', filterType: 'text' },
    {
      field: 'proposal_step.name',
      header: 'Proposal Step Name',
      filterType: 'text',
    },
    { field: 'role.name', header: 'Role', filterType: 'text' },
  ];
  filteredStagesList: any[] = [];
  currentUserRoleCode = sessionStorage.getItem('user_role_code');
  private subscriptions = new Subscription();
  currentSchemeId: any = 1;
  currentStage: number = 1;
  currentUserRoleId = sessionStorage.getItem('user_role_id');
  currentProposal: any;
  equipment: Equipment[] = [];
  system: System[] = [];
  filteredEquipment: Equipment[] = [];
  filteredSystem: System[] = [];
  tenderModes = [
    { label: 'Single Tender', value: 'Single Tender' },
    { label: 'Limited Tender', value: 'Limited Tender' },
    { label: 'Open Tender', value: 'Open Tender' },
  ];
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @ViewChild('draftSotrUpload') draftSotrUpload!: FileUpload;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private fb: FormBuilder,
    private messageService: MessageService,
    private schemeService: SchemeService,
    private route: ActivatedRoute,
    private permissionService: PermissionsService
  ) {
    this.proposalForm = this.fb.group({
      id: [''],
      proposalName: ['', Validators.required],
      description: [''],
      scheme: [null, Validators.required],
      status: [1],
      nomenclature: [''],
      platform: [''],
      tenderMode: [''],
      equipment: [''],
      system: [''],
      qtyReqd: ['', Validators.required],
      qtyPrototype: ['', Validators.required],
      qtyBulk: ['', Validators.required],
      estimatedDevelopmentCost: [''],
      estimatedUnitCost: [''],
      llp: [''],
      lpyear: [null],
      poev: [''],
      consignee: [''],

      // Technical details
      technologyInsertion: ['',Validators.required],
      justificationText: [''],
      exportPotential: [''],
      approvalOfSOTRs: [''],
    });
    this.routeForm = this.fb.group({
      step: ['', Validators.required],
      role: [''],
      user: [''],
      unit: [''],
      level: [{ value: '', disabled: true }],
      approved: [false],
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const scheme_id = params['scheme_id'];
      this.currentSchemeId = scheme_id || 1;
      this.getDraftProposals()
    });
    // this.getTabs();
    // this.apiCall();
    this.initializeNewProposalForm();

    this.items = [
      { label: 'Add Proposal', command: () => (this.activeIndex = 0) },
    ];

    // Show "Skip Stages" **only if it's update mode**
    if (this.isUpdateProposal) {
      console.log('show skip');
      this.items.push({
        label: 'Skip Stages',
        command: () => (this.activeIndex = 1),
      });
    }

    this.items.push({
      label: 'Route Configuration',
      command: () => {
        this.apiCallForTransaction();
        this.activeIndex = this.items.length - 1;
      },
    });
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  clear(table: any, searchInput: HTMLInputElement): void {
    searchInput.value = '';
    this.searchProposalQuery = '';
    this.lazy = true;
    this.getProposal(this.activeStatusTabIndex)
  }

  editorReady = false;
  rebuildEditor() {
    this.editorReady = false;
    setTimeout(() => {
      this.init = this.getTinyInit();
      this.editorReady = true;
    }, 0);
  }
  getTinyInit(): EditorComponent['init'] {
    return {
      readonly: this.isEditorDisabled,
    };
  }
  get isStep2Visible(): boolean {
    return this.currentUserRoleId != '6';
  }
  searchSchemes(event: AutoCompleteCompleteEvent) {
    let query = event.query.toLowerCase();
    this.filteredSchemes = this.schemes.filter(
      (scheme) =>
        scheme.name.toLowerCase().includes(query) ||
        scheme.description.toLowerCase().includes(query)
    );
    if (this.addMode === 'existing') {
      this.filteredSchemes = this.filteredSchemes.filter((scheme) =>
        scheme.phase?.includes(this.selectedPhaseId)
      );
    }
  }

  searchProposals(event: any) {
    this.searchProposalQuery = event.target.value.toLowerCase();
    // this.filterProposalsByStatus();
    // Note: PrimeNG pagination will automatically reset to first page when data changes
  }

  // Filter proposals by status tab
  filterProposalsByStatus() {
    const activeTab = this.proposalStatusTabs[this.activeStatusTabIndex];

    // Special handling for "New Proposal" tab (form)
    if (activeTab.status === 'form') {
      this.proposalData = []; // Empty array for form tab
      return;
    }

    let filteredData = this.filteredRecentProposals.filter(
      (proposal) => proposal.proposal_status === activeTab.status
    );

    // Apply search filter if there's a search query
    if (this.searchProposalQuery) {
      filteredData = filteredData.filter(
        (proposal) =>
          proposal.name.toLowerCase().includes(this.searchProposalQuery) ||
          proposal.description.toLowerCase().includes(this.searchProposalQuery) ||
          proposal.scheme.name?.toLowerCase().includes(this.searchProposalQuery)
      );
    }

    this.proposalData = filteredData;
  }

  // Handle proposal status tab change
  onProposalStatusTabChange(tab: any) {
    const tabIndex = tab.tab;
    this.activeStatusTabIndex = tab;

    if (tabIndex === 0) {
      this.initializeNewProposalForm();
      this.getDraftProposals()
    } else {
      // For other tabs, filter proposals by status
      this.getProposal(tab, 1)
      // this.filterProposalsByStatus();
    }
    // Note: PrimeNG pagination will automatically reset to first page when data changes
  }

  // Initialize form for new proposal
  initializeNewProposalForm() {
    this.proposalForm.reset();
    this.proposalForm.patchValue({
      scheme: parseInt(this.currentSchemeId)
    });
    this.selectedDraftProposal = null;
    this.selectedDmsFiles = [];
    this.getPushFiles();
    // Load schemes if not already loaded
    if (this.schemes.length === 0) {
      this.getSchemes();
      this.apiCall()
    }
  }

  /** Seed SOTR and SOC rows for Document Uploads (mandatory docs, same pattern as PDS/PRU in idex-from) */
  getPushFiles() {
    this.files = [
      { name: 'SOTR', description: 'SOTR', type_document: '.pdf', date: new Date().toISOString().substring(0, 10), uploaded_at: new Date().toISOString().substring(0, 10) },
      { name: 'SOC', description: 'SOC', type_document: '.pdf', date: new Date().toISOString().substring(0, 10), uploaded_at: new Date().toISOString().substring(0, 10) }
    ];
  }

  navigateToScheme(schemeName: any) {
    this.schemeService.setScheme(schemeName);
    this.router.navigate(['/proposal-dashboard'], {
      queryParams: {
        scheme: schemeName.name,
        id: schemeName.id,
        phase: this.activePhaseId,
      },
    });
  }

  confirmSkipStage() {
    const updatedStages = this.stages.map((stage) => {
      const isSkipped = stage.code === 'R-POC' ? true : stage.skipped || false;

      // Create a shallow copy and modify it
      const { week_timeline, percentage, ...rest } = stage;

      return {
        ...rest,
        skipped: isSkipped,
        week_timeline: week_timeline || null,
        percentage: percentage || null,
      };
    });

    const sub = this.apiService
      .postAPI(
        `/transaction/proposals/${this.selectedProposal.id}/steps/`,
        updatedStages
      )
      .subscribe((res: any) => {
        console.log('step submittedd');
        // this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Stages Skipped Successfully' });
        if (res.length > 0 && this.isUpdateProposal) {
          this.apiCallForTransaction();
        }
        if (
          res.message == 'Steps processed successfully' &&
          !this.isUpdateProposal
        ) {
          console.log('route submittedd called');
          // this.getStages(this.selectedScheme.id,'pass');
          this.onrouteFormSubmit();
        }
        // this.getProposal();
        const routeIndex = this.items.findIndex(
          (i) => i.label === 'Route Configuration'
        );
        if (routeIndex !== -1) {
          // this.activeIndex = routeIndex;
        }
      });
    this.subscriptions.add(sub);
  }

  skipStage(proposal: any) {
    this.isSkipStep = true;
  }
  searchQuery: string = '';
  getStatusBadgeClass(status: string): string {
    switch (status) {
      case 'approved':
        return 'bg-success';
      case 'pending':
        return 'bg-warning text-dark';
      case 'short_closed':
        return 'bg-secondary';
      case 'rejected':
        return 'bg-danger';
      default:
        return 'bg-info';
    }
  }

  getFieldValue(obj: any, fieldPath: string): any {
    if (!obj || !fieldPath) {
      return null;
    }
    try {
      return fieldPath.split('.').reduce((acc, part) => {
        if (acc && typeof acc === 'object' && part in acc) {
          return acc[part];
        }
        return undefined;
      }, obj);
    } catch {
      return undefined;
    }
  }

  addProposal(mode: 'new' | 'existing' = 'new') {
    this.transactionPhaseStages = [];
    this.addMode = mode;
    this.activeTabName = this.tabList[this.activeTabIndex]?.name || '';
    this.proposalForm.reset();
    this.routeForm.reset();
    this.proposalForm.get('scheme')?.disable();
    this.activeIndex = 0;
    this.addProposalVisible = true;
    this.isUpdateProposal = false;
    this.currentPhaseName = '';
    this.getSchemes(mode);
  }
  // onSubmit() {
  //   const data = {
  //     name: this.proposalForm.get('proposalName')?.value,
  //     description: this.proposalForm.get('description')?.value,
  //     scheme: this.proposalForm.get('scheme')?.value,
  //     phase: this.activePhaseId,
  //     status: 1,
  //   };

  //   if (this.isUpdateProposal) {
  //     const sub = this.apiService
  //       .putAPI(`/master/proposals/${this.selectedProposal.id}/`, data)
  //       .subscribe((res: any) => {
  //         this.selectedProposal = res;
  //         this.messageService.add({
  //           severity: 'success',
  //           summary: 'Success',
  //           detail: res.message || 'Proposal Updated Successfully',
  //         });
  //         this.apiCallForTransaction();
  //         // this.getStages(this.proposalForm.get('scheme')?.value, 'pass');
  //         this.getProposal();
  //         this.confirmSkipStage()
  //         this.activeIndex = 1;
  //       });
  //     this.subscriptions.add(sub);
  //   } else {
  //     // New proposal submission from the form
  //     const sub = this.apiService
  //       .postAPI('/master/proposals/', data)
  //       .subscribe((res: any) => {
  //         this.selectedProposal = res;
  //         this.messageService.add({
  //           severity: 'success',
  //           summary: 'Success',
  //           detail: res.message || 'Proposal Created Successfully',
  //         });

  //         // Reset form after successful submission
  //         this.proposalForm.reset();
  //         this.proposalForm.patchValue({
  //           scheme: parseInt(this.currentSchemeId)
  //         });

  //         // Refresh proposals data
  //         this.getProposal();
  //         //  this.getStages(this.proposalForm.get('scheme')?.value, 'pass');
  //         // this.confirmSkipStage()
  //         this.onNeedformSubmit()

  //         // Switch to "On going Proposal" tab to show the newly created proposal
  //         this.onProposalStatusTabChange(1);
  //       });
  //     this.subscriptions.add(sub);
  //   }
  // }
  isLoading: boolean = false;
  onNeedformSubmit(event: any) {
    this.isLoading = true;
    const v = this.proposalForm.value;
    const routePayload: any = {
      remark: event.internalComment,
      is_external: event.shareType === 'external',

    };

    if (event.shareType === 'external') {
      routePayload.unit_id = event.selectedUnit?.id;
      routePayload.command = event.selectedCommand;

    } else {
      routePayload.user = event.selectedUser?.id;
    }
    const payload: any = {
      proposal: { name: v.proposalName, description: v.description, scheme: v.scheme },
      need: {
        equipment_id: v.equipment, system_id: v.system, nomenclature: v.proposalName, qty_req: v.qtyReqd,
        amount: v.estimatedDevelopmentCost, platform: v.platform, mode_tendor: v.tenderMode, consignee: v.consignee,
        prototype_qty: v.qtyPrototype, bulk_qty: v.qtyBulk,
        unit_cost: v.estimatedUnitCost, justification: v.justificationText, formulation_sotr: v.approvalOfSOTRs,
        lpp_cost: v.llp, poev: v.poev, technical_details: v.technologyInsertion, proposed_item: v.exportPotential

      },
      route_conf: routePayload,
    };
    console.log(payload)
    const fd = new FormData();
    fd.append('data', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
    const meta: any[] = [];
    (this.selectedDmsFiles || []).forEach((it: any, i: number) => {
      if (!it?.file) return;
      const name = it.name || `file_${i + 1}`;
      fd.append('files', it.file, name);
      meta.push({ id: it?.id, name, description: it.description || '', type_document: it.type || it.file?.type || '', date: it.date || '' });
    });
    fd.append('files_meta', new Blob([JSON.stringify(meta)], { type: 'application/json' }));

    this.apiService.postAPI('/revenue/initiated/proposal/', fd).subscribe(
      (res: any) => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res?.message || 'Draft saved successfully.' });
        this.getDraftProposals(res.id);
        this.onProposalStatusTabChange(this.proposalStatusTabs[1])
        this.isLoading = false;

      },
      (err: any) => this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error || 'Failed to save draft.' })
    );


  }

  // Add this method to reset sharing form
  resetSharingForm() {
    this.shareType = null;
    this.permissionType = null;
    this.selectedUser = null;
    this.selectedUsers = [];
    this.selectedUnit = null;
    this.selectedUnits = [];
    this.internalComment = '';
    this.externalComment = '';
  }

  // Add validation method
  isFormValid(): boolean {
    if (!this.shareType || !this.permissionType) return false;

    if (this.shareType === 'internal') {
      if (this.permissionType === 'edit') {
        return !!this.selectedUser;
      } else {
        return this.selectedUsers && this.selectedUsers.length > 0;
      }
    } else {
      if (this.permissionType === 'edit') {
        return !!this.selectedUnit;
      } else {
        return this.selectedUnits && this.selectedUnits.length > 0;
      }
    }
  }

  insertIntermediateSteps(scheme: any, phaseId: any) {
    const currentPhase = this.tabList?.find((p) => p.id === phaseId);
    const phaseName = currentPhase?.name;

    this.currentPhaseName = phaseName;

    const firstStep = { label: 'Add Proposal' };
    const mandatoryStep = { label: 'Mandatory steps from Previous Phases' };
    const lastSteps = [
      { label: 'Skip Stages' },
      { label: 'Route Configuration' },
    ];

    const newSteps = [];

    if (
      phaseName === 'Prototype Development' ||
      phaseName === 'Mass Production'
    ) {
      newSteps.push(mandatoryStep);
    }

    this.items = [firstStep, ...newSteps, ...lastSteps];
  }

  next() {
    this.activeIndex += 1;
    this.getProposal();
  }
  initStepperItems() {
    this.items = [
      { label: 'Add Proposal', command: () => (this.activeIndex = 0) },
    ];

    if (this.isUpdateProposal) {
      console.log('show skip');
      this.items.push({
        label: 'Skip Stages',
        command: () => (this.activeIndex = this.items.length),
      });
    }

    this.items.push({
      label: 'Route Configuration',
      command: () => {
        this.apiCallForTransaction();
        this.activeIndex = this.items.length - 1;
      },
    });
  }

  updateProposal(proposal: any) {
    this.selectedProposal = proposal; // Store selected proposal
    this.isUpdateProposal = true;
    this.addProposalVisible = true;
    this.activeIndex = 0;
    this.proposalForm.patchValue({
      proposalName: proposal.name,
      scheme: proposal.scheme.id,
      // fund: proposal.fund,
      description: proposal.description,
    });

    // Make sure the scheme dropdown correctly displays the name
    this.populateScheme(proposal.scheme);
    this.getSchemes();
    // this.getFunds();
    // this.getStages(this.proposalForm.get('scheme')?.value, 'pass');
    // Important: Disable scheme control manually
    this.proposalForm.get('scheme')?.disable();
    this.initStepperItems();
  }
  //  Populate Scheme Dropdown Based on Stored ID
  populateScheme(schemeId: number) {
    const selectedScheme = this.schemes.find((s) => s.id === schemeId);
    if (selectedScheme) {
      this.proposalForm.patchValue({ scheme: selectedScheme.id });
    }
  }
  onUpdateSubmit() {
    let schemeId = this.selectedProposal.id;
    let payload = {
      name: this.proposalForm.get('proposalName')?.value,
      description: this.proposalForm.get('description')?.value,
      scheme: this.proposalForm.get('scheme')?.value.id,
      status: 1,
    };
    const sub = this.apiService
      .putAPI(`/master/proposals/${schemeId}/`, payload)
      .subscribe((res: any) => {
        if (res) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Proposal updated successfully',
          });
          this.isUpdateProposal = false;
          this.proposalForm.reset();
          this.selectedScheme = null;
        } else {
          this.messageService.add({
            severity: 'failed',
            summary: 'Failed',
            detail: res.detail,
          });
        }
      });
    this.subscriptions.add(sub);
    this.isUpdateProposal = false;
  }
  deleteProposal(proposal?: any) {
    this.isDeleteProposal = true;
    this.selectedProposal = proposal;
  }
  confirmDelete() {
    if (this.isDeleteProposal) {
      let schemeId = this.selectedProposal.id;
      const sub = this.apiService
        .deleteAPI(`/master/proposals/${schemeId}/`)
        .subscribe((res: any) => {
          // if (res) {
          this.isDeleteProposal = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Proposal Deleted Successfully',
          });
          // }
          this.getProposal();
        });
      this.subscriptions.add(sub);
    }
  }
  getSchemes(mode?: 'new' | 'existing') {
    const sub = this.apiService
      .getAPI('/master/scheme/')
      .subscribe((res: any) => {
        this.schemes = res;
        this.proposalForm.patchValue({
          scheme: parseInt(this.currentSchemeId),
        });
        this.filteredSchemes = [...this.schemes];
        if (mode === 'existing') {
          this.filteredSchemes = this.schemes.filter((scheme) =>
            scheme.phase?.includes(this.selectedPhaseId)
          );
        }
      });
    this.subscriptions.add(sub);
  }
  getUnit() {
    const sub = this.apiService
      .getAPI('/master/units/')
      .subscribe((res: any) => {
        this.unitList = res.data;
      });
    this.subscriptions.add(sub);
  }
  totalCount = 10
  getProposal(tab: any = '', page = 1) {
    this.proposalData = []
    // this.lazy=true;
    let url = `/master/proposals/?scheme=${this.currentSchemeId}&page=${page}`;
    if (tab) {
      url += `&proposal_status=${tab.status}`;
    }
    const sub = this.apiService.getAPI(url).subscribe((res: any) => {
      this.proposalData = res.results;
      this.totalCount = res.count;
      // this.filterProposalsByStatus(); // Apply initial filtering based on active tab
    });
    this.subscriptions.add(sub);
  }
  onPageChange(event) {
    const rows = event.rows;
    const first = event.first;
    const page = first / rows + 1;
    this.getProposal(this.activeStatusTabIndex, page);
  }
  onActiveIndexChange(event: any) {
    this.activeIndex = event;
  }
  setActiveIndex(index: number): void {
    this.activeIndex = index;

    // Handle role-specific actions
    if (this.currentUserRoleId == '6') {
      if (index === 2) {
        // Route Configuration for role 6
        this.apiCallForTransaction();
      }
    } else {
      if (index === 1) {
        // Route Configuration for other roles
        this.apiCallForTransaction();
      }
    }
  }
  onAllRolesSame(isSame: boolean) {
    const userId = sessionStorage.getItem('user_id');

    if (userId) {
      const matchedUser = this.userList.find((user) => user.id == userId);

      if (matchedUser) {
        if (isSame) {
          this.routeForm.patchValue({
            unit: matchedUser.unit.id,
            user: matchedUser.id,
          });
        } else {
          // Optionally reset the fields
          this.routeForm.patchValue({
            unit: null,
            user: null,
          });
        }
      } else {
        console.warn('User ID not found in users list.');
      }
    } else {
      console.warn('User ID not found in session storage.');
    }
  }
  // onrouteFormSubmit() {
  //   // if (this.routeForm.invalid) return;

  //   const formValue = this.routeForm.value;

  //   let payload;
  //   if (!formValue.approved) {
  //     payload = {
  //       status: 1,
  //       sequence: this.routeForm.get('level')?.value, // Convert level input to number
  //       proposal_step: formValue.step,
  //       user: formValue.user,
  //       role: formValue.role,
  //       unit: formValue.unit,
  //       is_final_approve: formValue.approved || false,
  //     };
  //   } else {
  //     let id = sessionStorage.getItem('user_id');
  //     let role = sessionStorage.getItem('user_role_id');
  //     payload = {
  //       proposal_step: formValue.step,
  //       user: formValue.user,
  //       unit: formValue.unit,
  //       role: this.roleList[2].id,
  //       is_final_approve: formValue.approved || true,
  //     };
  //   }

  //   const sub = this.apiService
  //     .postAPI(
  //       `/transaction/proposal-workflow/?proposal_step_id=${formValue.step}`,
  //       payload
  //     )
  //     .subscribe({
  //       next: (res: any) => {
  //         this.routeForm.reset();
  //         this.getProposalWorkflow(formValue.step);
  //       },
  //       error: (err) => {},
  //     });
  //   this.subscriptions.add(sub);
  // }
  onrouteFormSubmit() {
    const formValue = this.routeForm.value;
    const unit = Number(sessionStorage.getItem('unit_id'));
    const user = Number(sessionStorage.getItem('user_id'));

    if (!formValue.approved) {
      if (!this.isUpdateProposal) {
        this.apiService
          .getAPI(
            `/transaction/proposals/${this.selectedProposal.id}/steps/?skipped=False&phase_id=${this.activePhaseId}`
          )
          .subscribe({
            next: (res: any) => {
              const stepid = res?.[0]?.id;
              if (!stepid) {
                console.error('No step found for proposal.');
                return;
              }

              // ✅ Fetch roles and then continue
              this.apiService
                .getAPI('/access/user-roles/')
                .subscribe((rolesRes: any) => {
                  const rolePriority = ['INT', 'REC', 'APP'];
                  this.roleList = rolesRes.data
                    .filter((role: any) => rolePriority.includes(role.code))
                    .sort(
                      (a: any, b: any) =>
                        rolePriority.indexOf(a.code) -
                        rolePriority.indexOf(b.code)
                    );

                  if (!this.roleList.length) {
                    console.error('No roles found.');
                    return;
                  }

                  // const payload = {
                  //   status: 1,
                  //   sequence: 0,
                  //   proposal_step: stepid,
                  //   user,
                  //   unit,
                  //   role: this.roleList[0].id, // ✅ role is now defined
                  //   is_final_approve: formValue.approved || false
                  // };
                  const payload: any = {
                    proposal_step: stepid, // Ensure this is defined in your component
                    is_final_approve: false,
                    route_type: 'internal',
                    user: user,
                    unit: unit,
                    flag: 1,
                    permission_type: 'edit',
                    remark: '',
                  };

                  this.apiService
                    .postAPI(`/transaction/copy/proposal-workflow/`, payload)
                    .subscribe({
                      next: (res: any) => {
                        console.log('Workflow saved:', res);
                        this.routeForm.reset();

                        if (!this.isUpdateProposal) {
                          // sessionStorage.setItem('user_role_id', this.roleList[0].id);
                          // sessionStorage.setItem('user_role_name', this.roleList[0].name);
                          // this.messageService.add({
                          //   severity: 'success',
                          //   summary: 'Success',
                          //   detail: `Role has now been changed to ${this.roleList[0].name}.`
                          // })
                          this.getPermissions();
                          this.addProposalVisible = false;
                          this.navigateToSchemeTransaction(
                            this.proposalData[0],
                            this.activePhaseId
                          );
                        }
                      },
                      error: (err) => {
                        console.error('Workflow API error:', err);
                      },
                    });
                });
            },
            error: (err) => {
              console.error('Step API error:', err);
            },
          });
      } else {
        // Update proposal case
        // const payload = {
        //   status: 1,
        //   sequence: this.routeForm.get('level')?.value,
        //   proposal_step: formValue.step,
        //   user: formValue.user,
        //   role: formValue.role,
        //   unit: formValue.unit,
        //   is_final_approve: formValue.approved || false
        // };
        const payload: any = {
          proposal_step: formValue.step, // Ensure this is defined in your component
          is_final_approve: false,
          route_type: 'internal',
          user: formValue.user,
          unit: formValue.unit,
          flag: 1,
          permission_type: 'edit',
          remark: '',
        };

        console.log('Update Payload:', payload);
        this.apiService
          .postAPI(`/transaction/copy/proposal-workflow/`, payload)
          .subscribe({
            next: (res: any) => {
              console.log('Workflow saved:', res);
              this.routeForm.reset();
              this.getProposalWorkflow(formValue.step);
            },
            error: (err) => {
              console.error('Workflow API error:', err);
            },
          });
      }
    } else {
      // Approved case
      const payload = {
        proposal_step: formValue.step,
        user: formValue.user,
        unit: formValue.unit,
        role: this.roleList?.[2]?.id,
        is_final_approve: true,
      };
      console.log('Approved Payload:', payload);
      this.apiService
        .postAPI(`/transaction/proposal-workflow/`, payload)
        .subscribe({
          next: (res: any) => {
            console.log('Workflow saved:', res);
            this.routeForm.reset();
            this.getProposalWorkflow(formValue.step);
          },
          error: (err) => {
            console.error('Workflow API error:', err);
          },
        });
    }
  }

  getRoleList() {
    const sub = this.apiService
      .getAPI('/access/user-roles/')
      .subscribe((res: any) => {
        const rolePriority = ['INT', 'REC', 'APP']; // desired order
        const resp = res.data;
        this.roleList = resp
          .filter((role) => rolePriority.includes(role.code))
          .sort(
            (a, b) =>
              rolePriority.indexOf(a.code) - rolePriority.indexOf(b.code)
          );
      });
  }
  getUserList() {
    const unitId = Number(sessionStorage.getItem('unit_id'));
    const sub = this.apiService.getAPI('/account/users/').subscribe((res: any) => {
      let user = res.data;
      this.userList = user.filter((user: any) => {
        return user.unit?.id === unitId;
      });
    });

    this.subscriptions.add(sub);
  }


  onRoleChange(event: any) {
    this.roleID = event.value;
    this.tryFetchingSequence();
  }

  onUserChange(event: any) {
    this.userID = event.value;
    this.tryFetchingSequence();
  }
  onUnitChange(event: any) {
    let unit_id = event.value;
    this.userList = this.userListCopy.filter(
      (user) => user.unit?.id == unit_id
    );
  }
  tryFetchingSequence() {
    if (this.stepId && this.roleID && this.userID) {
      this.getSequence();
    }
  }

  getSequence() {
    const sub = this.apiService
      .getAPI(
        `/transaction/get-next-level/?proposal_step_id=${this.stepId}&role_id=${this.roleID}`
      )
      .subscribe((res: any) => {
        const sequenceValue = res.level ?? '';
        this.routeForm.get('level')?.patchValue(sequenceValue);
      });
    this.subscriptions.add(sub);
  }

  apiCallForTransaction() {
    this.getUnit();
    this.getRoleList();
    this.getUserList();
    const sub = this.apiService
      .getAPI(
        `/transaction/proposals/${this.selectedProposal.id}/steps/?skipped=False&phase_id=${this.activePhaseId}`
      )
      .subscribe((res: any) => {
        if (this.currentUserRoleId == '6') {
          // Role 6 gets full list
          this.stagesList = res;
        } else {
          // Other roles only get the first stage
          this.stagesList = res.length ? [res[0]] : [];
        }
        this.filteredStagesList = this.stagesList.filter(
          (step) => !step.skipped
        );
        this.routeForm.get('step')?.setValue(this.stagesList[0].id);
        if (this.addMode == 'new') {
          let unit = sessionStorage.getItem('unit_id');
          let user = sessionStorage.getItem('user_id');
          this.userID = Number(user);
          this.roleID = this.roleList[0]?.id;
          this.routeForm.get('unit')?.patchValue(Number(unit));
          this.routeForm.get('user')?.patchValue(Number(user));
          this.routeForm.get('role')?.patchValue(this.roleList[0]?.id);
        }
        this.stepId = this.stagesList[0].id;
        this.tryFetchingSequence();
        this.getProposalWorkflow(this.stagesList[0].id);
      });
    this.subscriptions.add(sub);
  }
  // getStages(schemeId: any, pass: any) {
  //   if (this.isUpdateProposal && pass == 'pass') {
  //     const sub = this.apiService
  //       .getAPI(
  //         `/transaction/proposals/${this.selectedProposal.id}/steps/?phase_id=${this.activePhaseId}`
  //       )
  //       .subscribe((res: any) => {
  //         this.stages = res.map((item: any) => ({
  //           // master_step: item.master_step,
  //           step_mapping: item.step_mapping,
  //           name: item.name,
  //           sequence: item.sequence,
  //           skipped: item.skipped,
  //           code: item.code,
  //           remark: item.remark,
  //           isSelected: item.isSelected,
  //           week_timeline: item.week_timeline,
  //           percentage: item.percentage,
  //         }));
  //         this.calculateCompletionSum();
  //         if (res.length < 1) {
  //           this.apiService
  //             .getAPI(`/master/scheme-step/mapping/?scheme=${schemeId}`)
  //             .subscribe((res: any) => {
  //               this.stages = res.map((item: any) => ({
  //                 // master_step: item.step.id,
  //                 step_mapping: item.id,
  //                 name: item.step.name,
  //                 sequence: item.sequence,
  //                 skipped: item.step.code == 'R-POC' ? true : false,
  //                 code: item.step.code,
  //                 week_timeline: item.week_timeline,
  //                 percentage: item.percentage,
  //                 remark: '',
  //                 isSelected: false,
  //               }));
  //               this.calculateCompletionSum();
  //               this.confirmSkipStage();
  //               // if (this.currentUserRoleId != '6') {
  //               //   this.confirmSkipStage();
  //               // }
  //             });
  //         }
  //       });
  //     this.subscriptions.add(sub);
  //   } else {
  //     const sub = this.apiService
  //       .getAPI(`/master/scheme-step/mapping/?scheme=${schemeId}`)
  //       .subscribe((res: any) => {
  //         this.stages = res.map((item: any) => ({
  //           // master_step: item.step.id,
  //           step_mapping: item.id,
  //           name: item.step.name,
  //           sequence: item.sequence,
  //           skipped: item.step.code == 'R-POC' ? true : false,
  //           code: item.step.code,
  //           remark: '',
  //           week_timeline: item.week_timeline,
  //           percentage: item.percentage,
  //           isSelected: false,
  //         }));
  //         this.calculateCompletionSum();
  //         // this.confirmSkipStage();
  //         // if (this.currentUserRoleId != '6') {
  //         //   this.confirmSkipStage();
  //         // }
  //       });
  //     this.subscriptions.add(sub);
  //   }
  // }

  getProposalWorkflow(id: any) {
    this.RouteUserList = [];
    const sub = this.apiService
      .getAPI(`/transaction/proposal-workflow/?proposal_step_id=${id}`)
      .subscribe((res: any) => {
        // this.RouteUserList = res.data;
        const allData = res.data || [];

        // Filter only users with role.code 'INT', 'APP', or 'REC'
        this.RouteUserList = allData.filter(
          (user: any) =>
            ['INT', 'APP', 'REC'].includes(user.role.code) ||
            user.is_final_approve
        );
      });
    this.subscriptions.add(sub);
  }

 navigateToSchemeTransaction(schemeName: any, phaseId: any) {

  const isShortClose = schemeName.proposal_status === 'short_close' || schemeName.proposal_status === 'approved';

  this.router.navigate(['/transaction'], {
    queryParams: {
      id: schemeName.id,
      name: schemeName.name,
      scheme: schemeName.scheme.id,
      phase: phaseId,
      mode: this.addMode,
      step: schemeName.step_summary.current_step_id,
      short_close: isShortClose   
    },
  });

}

  deleteUser(user: any) {
    const sub = this.apiService
      .deleteAPI(`/transaction/proposal-workflow/${user.id}/`)
      .subscribe((res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'User deleted successfully.',
        });
        this.getProposalWorkflow(user.proposal_step.id);
      });
    this.subscriptions.add(sub);
  }
  onStepChange(event: any) {
    this.stepId = event.value;
    const sub = this.apiService
      .getAPI(`/transaction/proposal-workflow/?proposal_step_id=${event.value}`)
      .subscribe((res: any) => {
        this.RouteUserList = res.data;
        if (res.data[0]) {
          this.routeForm
            .get('approved')
            .patchValue(res.data[0]?.is_final_approve || false);
        } else {
          this.routeForm.get('approved').patchValue(false);
        }
      });
    this.subscriptions.add(sub);
    this.tryFetchingSequence();
  }
  filteredProposals(schemeName: string): any[] {
    return this.proposalData.filter((p) => p?.scheme?.name === schemeName);
  }
  // getTabs() {
  //   const sub = this.apiService
  //     .getAPI(`/master/scheme/${this.currentSchemeId}/phases/`)
  //     .subscribe((res) => {
  //       this.tabList = res;
  //       this.activePhaseId = this.tabList[0].id;
  //       this.getProposal();
  //     });
  //   this.subscriptions.add(sub);
  // }
  // onTabChange(event: any): void {
  //   this.activeTabIndex = event.index;
  //   // Note: PrimeNG pagination will automatically reset to first page when data changes
  //   this.activePhaseId = this.tabList[event.index]?.id;
  //   this.selectedPhaseId = this.tabList[event.index]?.id;
  //   this.getProposal();
  // }

  // getPagedProposals(): any[] {
  //   const start = (this.currentPage - 1) * this.itemsPerPage;
  //   const end = start + this.itemsPerPage;
  //   return this.proposalData.slice(start, end);
  // }
  // getDialogHeader(): string {
  //   if (this.isUpdateProposal) {
  //     return 'Update Proposal';
  //     // : `Update Proposal on ${this.activeTabName}`;
  //   } else {
  //     return this.addMode === 'new'
  //       ? 'Add New Proposal'
  //       : `Add Proposal to ${this.activeTabName}`;
  //   }
  // }

  fetchAndSubmitProposalSteps(
    schemeId: number,
    scheme_Name: string,
    proposalId: number,
    phaseId: number
  ): void {
    let optionalStepCodes: string[] = [];
    const scheme = this.schemes.find((s) => s.id === schemeId);
    if (!scheme) {
      console.error('Scheme not found for ID:', schemeId);
      return;
    }

    const schemeName = scheme.name;
    optionalStepCodes = [
      'R-ND',
      'R-AIP',
      'R-NOQA',
      'R-VI',
      'R-RFP-SOC',
      'R-AoN',
      'R-PRFPM',
      'R-FS',
      'R-PBC',
      'R-TEC',
      'R-BM',
      'R-FO',
      'R-PSO',
      'Rev_011',
      'Rev_012',
      'idex_007',
      'Rev_017',
      'Rev_013',
      'Rev_014',
    ];

    const index = this.tabList.findIndex(
      (p) => p.name === this.currentPhaseName
    );

    if (index > 0) {
      for (let i = 0; i < index; i++) {
        const phase = this.tabList[i];

        const sub = this.apiService
          .getAPI(
            `/master/scheme-step/mapping/?scheme=${schemeId}&phase_id=${phase.id}`
          )
          .subscribe(
            (res: any) => {
              const stagePayload = res.map((item: any) => {
                const skipped = !optionalStepCodes.includes(item.step.code);

                return {
                  step_mapping: item.id,
                  name: item.step.name,
                  sequence: item.sequence,
                  skipped,
                  code: item.step.code,
                  remark: '',
                  isSelected: false,
                  ...(skipped === false && { make_initiator: true }), // ✅ Conditionally add the key
                };
              });

              this.transactionPhaseStages.push({
                phase: phase,
                stages: stagePayload,
              });

              this.apiService
                .postAPI(
                  `/transaction/proposals/${proposalId}/steps/`,
                  stagePayload
                )
                .subscribe(
                  (submitRes: any) => { },
                  (submitErr) => { }
                );
            },
            (err) => { }
          );
        this.subscriptions.add(sub);
      }
    }
  }

  setActivePhase(phaseName: string) {
    this.currentPhaseName = phaseName;
  }



  getPermissions() {
    let role_id = sessionStorage.getItem('user_role_id');
    this.apiService
      .getAPI(`/access/get-permissions/?role_id=${role_id}`)
      .subscribe((res: any) => {
        this.permissionService.setPermissions(res);
      });
  }
  allowOnlyNumbers(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight'];
    if (allowedKeys.includes(event.key)) return;

    const isNumber = /^[0-9]$/.test(event.key);
    if (!isNumber) {
      event.preventDefault();
    }
  }
  apiCall() {
    this.apiService.getAPI('/master/system-master/').subscribe((res: any) => {
      this.system = res.data;
      this.filteredSystem = res.data;
    });
    this.apiService.getAPI('/master/equipment-master/').subscribe((res: any) => {
      this.equipment = res.data;
      this.filteredEquipment = res.data;
    });
  }
  isSectionOpen = {
    basicInfo: false,
    draftProposals: false,
    equipment: false,
    quantity: false,
    cost: false,
    detailed: false,
    uploads: false,
    documentUploads: false
  };
  files: any[] = [];
  toggleSection(section: keyof typeof this.isSectionOpen): void {
    this.isSectionOpen[section] = !this.isSectionOpen[section];
  }


  shareType: string;
  permissionType: string;
  selectedUser: any; // For single selection (edit)
  selectedUsers: any[] = []; // For multiple selection (view/comment)
  selectedUnit: any; // For single selection (edit)
  selectedUnits: any[] = []; // For multiple selection (view/comment)

  displayDialogN = false;
  selectedUserN: any;
  internalComment: string
  externalComment: string

  // Add New Equipment/System dialog
  showAddEquipmentDialog = false;
  showAddSystemDialog = false;
  newEquipmentName = '';
  newSystemName = '';
  openDialog() {
    this.displayDialogN = true;
    // this.getUserList();
    // this.getUnit()
  }


  draftProposals: any[] = [];
  getDraftProposals(id?: number) {
    this.draftProposals = [];
    this.apiService.getAPI('/revenue/save-draft/proposal/').subscribe((res: any) => {
      this.draftProposals = res;
      const draftProposal = this.draftProposals.find((draft: any) => draft.id === id);
      if (draftProposal) {
        this.populateDraftProposal(draftProposal);
      }
    });
  }
  approveAPSO() {
    this.selectedProposals
    console.log('APSO Approved', this.selectedProposals);
  }
  selectedDraftProposal: any;
  populateDraftProposal(draft: any) {
    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Draft proposal populated successfully.' });
    this.selectedDraftProposal = draft;
    this.proposalForm.patchValue({
      id: draft.id,
      proposalName: draft.nomenclature,
      description: draft.description,
      scheme: 1,
      equipment: draft.equipment?.id,
      system: draft.system?.id,
      qtyReqd: draft.qty_req,
      estimatedDevelopmentCost: draft.amount,
      tenderMode: draft.mode_tendor,
      platform: draft.platform,
      consignee: draft.consignee,
      qtyPrototype: draft.prototype_qty,
      qtyBulk: draft.bulk_qty,
      estimatedUnitCost: draft.unit_cost,
      justificationText: draft.justification,
      approvalOfSOTRs: draft.formulation_sotr,
      llp: draft.lpp_cost,
      poev: draft.poev,
      technologyInsertion: draft.technical_details,
      exportPotential: draft.proposed_item,
    });
    this.scrollToCreateProposalSection();
  }
  scrollToCreateProposalSection(): void {
    this.createProposal?.nativeElement?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }


  selectedDmsFiles: any[] = [];
  onDocumentUpload(data: any) {
    this.selectedDmsFiles.push(data);
  }
  selectedDmsFilesPayload: any[] = [];

  saveDraft() {
    // Validate mandatory SOTR and SOC documents (same logic as PDS/PRU in idex-from)
    let filesToCheck: any[] = [];
    if (this.uploadDocumentComponent && this.uploadDocumentComponent['documentsArray']) {
      filesToCheck = this.uploadDocumentComponent['documentsArray'].controls
        .map((control: any) => control.value)
        .filter((val: any) => val && val.name);
    } else {
      filesToCheck = [...this.selectedDmsFiles];
    }
    let sotrFile: any = null;
    let socFile: any = null;
    filesToCheck.forEach((file: any) => {
      const fileName = (file.name || '').toUpperCase().trim();
      const hasFile = file.file && (file.file instanceof File || file.file?.name || file.file || typeof file.file === 'string');
      if (fileName === 'SOTR' && hasFile) {
        if (!sotrFile) sotrFile = file;
      } else if (fileName === 'SOC' && hasFile) {
        if (!socFile) socFile = file;
      }
    });
    // if (!sotrFile || !socFile) {
    //   const missingFiles = [];
    //   if (!sotrFile) missingFiles.push('SOTR');
    //   if (!socFile) missingFiles.push('SOC');
    //   this.messageService.add({
    //     severity: 'error',
    //     summary: 'Validation Error',
    //     detail: `Please upload both SOTR and SOC documents with files attached. Missing: ${missingFiles.join(' and ')}.`
    //   });
    //   return;
    // }

    const v = this.proposalForm.value;
    const payload: any = {
      proposal: { name: v.proposalName, description: v.description, scheme: v.scheme },
      need: {
        equipment_id: v.equipment || '', system_id: v.system || '', nomenclature: v.proposalName || '', qty_req: v.qtyReqd || '',
        amount: v.estimatedDevelopmentCost || '', platform: v.platform || '', mode_tendor: v.tenderMode || '', consignee: v.consignee || '',
        prototype_qty: v.qtyPrototype || '', bulk_qty: v.qtyBulk || '',
        unit_cost: v.estimatedUnitCost || '', justification: v.justificationText || '', formulation_sotr: v.approvalOfSOTRs || '',
        lpp_cost: v.llp || '', poev: v.poev || '', technical_details: v.technologyInsertion || '',
        proposed_item: v.exportPotential || '',
      },
      action: this.proposalForm.get('id')?.value ? 'update' : 'create'
    };
    if (payload.action === 'update' && this.selectedDraftProposal) {
      payload.proposal.proposal_id = this.selectedDraftProposal.proposal_id;
      payload.need.need_id = this.selectedDraftProposal.id;
    }
    const fd = new FormData();
    fd.append('data', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
    const meta: any[] = [];
    (this.selectedDmsFiles || []).forEach((it: any, i: number) => {
      if (!it?.file) return;
      const name = it.name || `file_${i + 1}`;
      fd.append('files', it.file, name);
      meta.push({ id: it?.id, name, description: it.description || '', type_document: it.type || it.file?.type || '', date: it.date || '' });
    });
    fd.append('files_meta', new Blob([JSON.stringify(meta)], { type: 'application/json' }));

    this.apiService.postAPI('/revenue/save-draft/proposal/', fd).subscribe(
      (res: any) => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res?.message || 'Draft saved successfully.' });
        this.getDraftProposals(res.id);
        this.selectedDmsFiles = []
      },
      (err: any) => this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error || 'Failed to save draft.' })
    );
  }

  onSubmitdataPrint(event: any) {


  }

  addNewEquipment() {
    const name = this.newEquipmentName?.trim();
    if (!name) return;
    this.apiService.postAPI('/master/equipment-master/', { name }).subscribe({
      next: (res: any) => {
        const newItem = res.data || res;
        this.equipment.push(newItem);
        this.filteredEquipment = [...this.equipment];
        this.proposalForm.get('equipment')?.setValue(newItem.id);
        this.showAddEquipmentDialog = false;
        this.newEquipmentName = '';
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Equipment added successfully.' });
      },
      error: (err: any) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error?.message || 'Failed to add equipment.' });
      }
    });
  }

  addNewSystem() {
    const name = this.newSystemName?.trim();
    if (!name) return;
    this.apiService.postAPI('/master/system-master/', { name }).subscribe({
      next: (res: any) => {
        const newItem = res.data || res;
        this.system.push(newItem);
        this.filteredSystem = [...this.system];
        this.proposalForm.get('system')?.setValue(newItem.id);
        this.showAddSystemDialog = false;
        this.newSystemName = '';
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'System added successfully.' });
      },
      error: (err: any) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error?.message || 'Failed to add system.' });
      }
    });
  }

}
interface Equipment {
  id: number;
  name: string;
}

interface System {
  id: number;
  name: string;
}